var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97021 17.4454H3.24253C2.8299 17.4454 2.49504 17.1105 2.49504 16.6979V3.24257C2.49504 2.82994 2.82994 2.49507 3.24253 2.49507H9.97021C10.3836 2.49507 10.7177 2.16094 10.7177 1.74757C10.7177 1.3342 10.3836 1 9.97021 1H3.24253C2.00615 1 1 2.00618 1 3.24257V16.6979C1 17.9342 2.00615 18.9404 3.24253 18.9404H9.97021C10.3836 18.9404 10.7177 18.6063 10.7177 18.1929C10.7177 17.7795 10.3836 17.4454 9.97021 17.4454Z",
    fill: "#4F4A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7768 9.4381L14.2319 4.953C13.9388 4.66296 13.4649 4.66672 13.1749 4.96049C12.8849 5.25426 12.8878 5.72743 13.1824 6.01747L16.4303 9.2228H7.72699C7.31362 9.2228 6.97949 9.55693 6.97949 9.9703C6.97949 10.3837 7.31362 10.7178 7.72699 10.7178H16.4303L13.1824 13.9232C12.8879 14.2132 12.8856 14.6864 13.1749 14.9802C13.3214 15.1282 13.5143 15.2029 13.7071 15.2029C13.897 15.2029 14.0869 15.1312 14.2319 14.9876L18.7768 10.5025C18.9188 10.362 18.9995 10.1706 18.9995 9.97027C18.9995 9.77002 18.9196 9.5794 18.7768 9.4381Z",
    fill: "#4F4A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.5407cac2dc509ccb72427d5a8e4f8272.svg";
export { ForwardRef as ReactComponent };